export default __webpack_public_path__ + "static/flag-at-22f65000c7ef184d1dce6f1119a16357.svg";